export { default } from '@relo/sports-components/es/SlabNavItem';
export * from '@relo/sports-components/es/SlabNavItem';
